import React from "react";
const ArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.999 9L6 14.241 6.657 15 11.999 10.334 17.343 15 18 14.241z",
    transform: "translate(-129 -185) translate(97 105) translate(23 71) rotate(-90 21 12) matrix(1 0 0 -1 0 24)"
  }
)))))));
export {
  ArrowIcon
};
//# sourceMappingURL=arrow-icon.js.map
